// the actions a TablesViewEnum.Link column can raise, the gridview response
// names one of these keys and the consuming table decides what it does
export const TablesViewActionsEnum = {
  OpenForm: {
    key: "open-form",
  },
};
